import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
export const InfoLabelMessage = ({ icon = _jsx(InfoOutlinedIcon, { color: "secondary", fontSize: "small" }), message, }) => {
    return (_jsxs(Stack, { direction: "row", justifyContent: "flex-start", alignItems: "center", width: "100%", spacing: 1 / 2, children: [icon, _jsx(Typography, { color: "textSecondary", variant: "caption", children: message })] }));
};
//# sourceMappingURL=InfoLabelMessage.js.map